import { createSelector } from "reselect"
import { get, chain, pick } from "lodash"
import { buildContributorKey } from "helpers/contributors"

const EMPTY_ARRAY = []

// Contributors
const getRawContributors = state => get(state, "global.data.marginalContributors.data.model.simulation.riskContributors", EMPTY_ARRAY)
const getRebalancedContributors = state => get(state, "modules.rebalance.rebalancedRiskContributors", EMPTY_ARRAY)

// Grouped Contributors
const getRawGroupedContributors = state => get(state, "global.data.groupedMarginalkContributors.data.model.simulation.groupedRiskContributors", EMPTY_ARRAY)
const getGroupedRebalancedContributors = state => get(state, "modules.rebalance.rebalancedGroupedRiskContributors", EMPTY_ARRAY)

export const getMarginalContributors = createSelector(
  [getRawContributors],
  computeMarginalContributors,
)

export const getGroupedMarginalContributors = createSelector(
  [getRawGroupedContributors],
  computeMarginalContributors,
)

export const getRebalancedMarginalContributors = createSelector(
  [getRebalancedContributors],
  computeMarginalContributors,
)

export const getGroupedRebalancedMarginalContributors = createSelector(
  [getGroupedRebalancedContributors],
  computeMarginalContributors,
)

function computeMarginalContributors(contributors) {
  return chain(contributors)
    .keyBy(buildContributorKey)
    .mapValues((contributor) => ({
      total: contributor.exposureRiskCorrelation,
      ...pick(contributor.attribution.exposureRiskCorrelation, ["specific", "factors"]),
    }))
    .value()
}
